// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"448":"candidateDetails","697":"candidateList","929":"terms","957":"alerts"}[chunkId] + "." + {"448":"38de0012","697":"50acd883","929":"98168dae","957":"3cb625a6"}[chunkId] + ".js";
};